// plugins/vuex-persistedstate.js

import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
  if (process.client) {
    createPersistedState({
      paths: ['lan'], // 仅持久化 userInfo 和 lan
      storage: localStorage, // 使用 localStorage 进行存储
    })(store);
  }
};
